import React, { useEffect } from 'react';
import { Form, Input, Checkbox, Collapse } from 'antd';
import BlogService from '../../services/BlogService';
import { usePersistedStore } from '../../store/persisted-store';
import { useNonePersistedStore } from '../../store/non-persisted-store';
const { Panel } = Collapse

export default function PostForm({ post, onSubmit }) {
    const { business } = usePersistedStore();
    const { BLOG_LOADING, GET_POSTS_SUCCESS, posts } = useNonePersistedStore()
    const [form] = Form.useForm();
    const loading = posts.loading;
    const currentBusiness = business.currentBusiness;
    const { token } = currentBusiness;

    async function onFinish(values) {
        BLOG_LOADING(true)
        await BlogService.postBlogPostService({
            wpId: post.wpId,
            id: post.id,
            title: values.title,
            orderbyId: values.orderbyId,
            excerpt: values.excerpt,
            enable: values.enable ? 1 : 0
        }, token).then(res => {
            BLOG_LOADING(false)
            getPosts()
            onSubmit()
        }).catch(() => {
            BLOG_LOADING(false)
        })
    };

    function getPosts() {
        BLOG_LOADING(true)
        BlogService.getPostsService(token).then(res => {
            GET_POSTS_SUCCESS(res.data)
        }).catch(() => { })
    }

    useEffect(() => {
        form.setFieldsValue({
            ...post,
        });
    }, [post])

    const layout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
    }

    return (
        <Form
            form={form}
            {...layout}
            layout="horizontal"
            name="edit_post"
            onFinish={onFinish}>
            <Collapse defaultActiveKey={['1', '2']}>
                <Panel header="اطلاعات" key="1">
                    <Form.Item name="title" label="عنوان">
                        <Input />
                    </Form.Item>
                    <Form.Item name="excerpt" label="خلاصه">
                        <Input.TextArea rows={7} />
                    </Form.Item>
                    <Form.Item name="orderbyId" label="مرتب سازی (ترتیب)">
                        <Input />
                    </Form.Item>
                </Panel>
                <Panel header="تنظیمات" key="2">
                    <Form.Item name="enable" valuePropName="checked">
                        <Checkbox>فعال بودن</Checkbox>
                    </Form.Item>
                </Panel>
            </Collapse>
            <br />
            <button type="primary" className="btn btn-primary waves-effect waves-light" htmltype="submit" style={{ width: "100%" }}>
                <i className={`${loading ? "bx bx-loader bx-spin" : "bx bx-check-double"} "font-size-14 align-middle mr-2 ml-5"`}></i>ثبت
            </button>
        </Form>
    )
}